export const WidgetEventTypeKeys = Object.freeze({
  error: 'error',
  fullscreen: 'fullscreen',
  window: 'window',
  custom: 'custom',
});

export const WidgetEventTypes = Object.freeze({
  [WidgetEventTypeKeys.error]: 'onError',
  [WidgetEventTypeKeys.fullscreen]: 'onFullScreenMode',
  [WidgetEventTypeKeys.window]: 'onWindowMode',
  [WidgetEventTypeKeys.custom]: 'onCustom',
});

const postGenericFrameMessage = (type, payload) => {
  window.parent.postMessage({ type, payload }, '*');
};

export const sendIframeError = (error) => {
  postGenericFrameMessage(WidgetEventTypeKeys.error, { error });
};

export const sendIFrameFullScreen = (zIndex, visibility) => {
  const style = {
    ...(visibility ? { visibility } : {}),
    ...(zIndex ? { zIndex } : {}),
  };

  postGenericFrameMessage(WidgetEventTypeKeys.fullscreen, style);
};

export const sendiFrameWindowed = (visibility) => {
  postGenericFrameMessage(WidgetEventTypeKeys.window, visibility ? { visibility } : {});
};
